<div class="target-picker-tree">
    <div class="filter-bar" *ngIf="filterBarVisible">
        <res-filter [filterInputAutoId]="automationId" [clearButtonDataAutoId]="automationId" [maxChars]=32
            [placeholder]='"Filter (2+ chars.) ..."' [callback]="filterData.bind(this)"
            [autofocusInput]="inputAutoFocused" [isFilteringInProgress]="filteringInProgress"></res-filter>
        <res-custom-checkbox *ngIf="hideEmptyTargetVisible" [automationId]="automationId + '-hide-empty-targets'"
            content="Hide Empty Views" [(ngModel)]="hideEmptyTargets" (ngModelChange)="hideEmptyTargetsChanged()"
            [labelPaddingLeft]="10" [labelPaddingRight]="10">
        </res-custom-checkbox>
    </div>
    <div class="tree-container">
        <res-generic-tree
            customClasses="generic-tree-picker-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top"
            [automationId]="automationId" [initialData]="nodes" [allowDeselection]="true"
            [selectedNodeChangedCallback]="selectedNodeChangedCallback" [doubleClickAction]="doubleClickAction"
            [finishLoadingCallback]="targetPickerTreefinishLoadingCallback">
        </res-generic-tree>
    </div>
</div>